import { useApolloTheme } from '@experiences/theme';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import Tokens from '@uipath/apollo-core';
import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import React from 'react';

import { BottomPageOptions } from './subcomponents/BottomPageOptions';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            backgroundPosition: '0 0',
            backgroundSize: '20px 20px',
            height: '100%',
            width: '100%',
            display: 'flex',
            overflow: 'auto',
            flex: 1,
        },
        center: {
            alignItems: 'center',
            flexDirection: 'column',
        },
    }),
);

export const UiBackground: React.FC<PropsWithChildren<{
    center?: boolean;
    withBottomOptions?: boolean;
    isRedesign?: boolean;
    onlyLanguageBottomPage?: boolean;
}>> = ({
    children, center, withBottomOptions = true, isRedesign = false, onlyLanguageBottomPage = false,
}) => {
    const classes = useStyles();
    const { themeId } = useApolloTheme();

    return (
        <div
            className={clsx(classes.root, center ? classes.center : '')}
            style={{
                backgroundImage: !isRedesign
                    ? themeId === 'light' || themeId === 'light-hc'
                        ? `radial-gradient(${Tokens.Colors.ColorGray200} 15%, ${Tokens.Colors.ColorGray100} 15%)`
                        : `radial-gradient(${Tokens.Colors.ColorInk650} 15%, ${Tokens.Colors.ColorInk700} 15%)`
                    : '',
                backgroundColor: isRedesign
                    ? themeId === 'light' || themeId === 'light-hc'
                        ? Tokens.Colors.ColorBlueSecondary100
                        : Tokens.Colors.ColorBackgroundDark
                    : '',
            }}
        >
            {children}
            {withBottomOptions && <BottomPageOptions hideLinksBottomPage={onlyLanguageBottomPage} />}
        </div>
    );
};
